var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcContent',{class:{'icon-loading': _vm.loading},attrs:{"app-name":"vueexample"}})
}
var staticRenderFns = []

export { render, staticRenderFns }